import EditJobLocationCoordinates from "./EditJobLocationCoordinates";

const ParcelInteractions = () => <EditJobLocationCoordinates />;

export default ParcelInteractions;
